import React from 'react';
import Img from '../../Img';
import { LinkAnchor } from '../../Links';

import styles from './slide.module.scss';

const bgImg = (imageObj) => {
    if (imageObj && imageObj.oneX && imageObj.twoX && imageObj.threeX) {
        return (
            <Img
                useRawSrcSet={true}
                src={imageObj.default}
                srcSet={`${imageObj.oneX} 2x, ${imageObj.twoX} 3x`}
                style={{ left: '0%' }}
            />
        );
    } if (imageObj && imageObj.default) {
        return (
            <Img
                src={imageObj.default}
                style={{ left: '0%' }}
            />
        );
    }
    return null;
};

const FeaturedCardSlide = (props) => {
    const { image } = props;
    const desktopImg = image && image.desktop;
    const mobileImg = image && image.mobile;

    return (
        <div className={`${styles.slideWrapper} ${props.currentIndex === props.index ? styles.active : ''}`}>
            <div className={styles.slide}>
                <div className={styles.title}>
                    {props.title}
                </div>
                <div className={styles.copy}>
                    {props.copy}
                </div>
                <LinkAnchor href={props.url}>
                    <div className={styles.image}>
                        <picture className={`${styles.img} d-none d-sm-block`} style={props.imgStyle}>
                            {bgImg(desktopImg)}
                        </picture>
                        <picture className={`${styles.img} d-block d-sm-none`} style={props.imgStyle}>
                            {bgImg(mobileImg)}
                        </picture>
                    </div>
                </LinkAnchor>
            </div>
        </div>
    );
};

export default FeaturedCardSlide;
